function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__a",
  x1: "100%",
  x2: "0%",
  y1: "0%",
  y2: "67.961%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#0052A5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0075E2"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 22,
  fill: "url(#prefix__a)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.207 12.187c1.66 1.659 3.008 2.48 3.733 2.922.724.443 1.106-.12 1.172-.195.065-.076.178-.232.455-.587l.591-.775c.3-.415.834-.532 1.25-.26l4.124 2.697c.415.272.532.834.26 1.25l-.351.596c-.26.44-.436.76-.593 1.002-.178.276-.852 1.223-2.585 1.089-1.984-.154-5.03-.6-10.113-5.682C1.066 9.16.62 6.114.467 4.13c-.133-1.734.813-2.407 1.09-2.585.242-.158.562-.335 1.002-.593L3.155.6C3.57.33 4.133.447 4.404.862l2.699 4.125c.27.414.152.949-.261 1.248l-.776.592c-.355.276-.51.39-.586.455-.075.065-.638.447-.195 1.172.441.723 1.263 2.073 2.922 3.733zM11.003 7.053c.616-.063 1.253.14 1.725.613.468.467.673 1.099.613 1.71M11.026 5.087c1.104-.028 2.217.379 3.06 1.22.848.849 1.255 1.972 1.22 3.084M10.986 3.253c1.621-.076 3.268.505 4.505 1.743 1.206 1.206 1.79 2.8 1.747 4.382",
  transform: "translate(12 12)"
})));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.987ed662.svg";
export { ForwardRef as ReactComponent };